import { useEffect } from 'react';

import {
  usePageConfig,
  useTabContentConfig,
} from '../components/PageConfigProvider/PageConfigProvider';
import { usePageState } from '../components/PageState/PageStateProvider';
import { usePrimaryFilterState } from '../filters/hooks/usePrimaryFilterState';

export const useSyncPrimaryEntities = () => {
  const { pageState, dispatch: pageDispatch } = usePageState();
  const { config: pageConfig } = usePageConfig();
  const { primaryFilter: tabPrimaryFilter, items: tabItems } =
    useTabContentConfig();
  const { primaryFilter } = usePrimaryFilterState(tabPrimaryFilter?.id);

  const selections = primaryFilter?.selections;

  const tabs = pageConfig.tabs;

  useEffect(() => {
    const validSelectionIds = new Set(
      selections?.map((s) => s.id.split('_').pop() ?? s.id) ?? []
    );
    const pageItemIds = new Set([
      ...tabs.flatMap((tab) => tab.tabContent.items.map((item) => item.id)),
      ...tabItems.map((item) => item.id),
    ]);

    const plotIdsToClear = Object.entries(pageState.primaryEntities)
      .filter(([itemId, entity]) => {
        if (!pageItemIds.has(itemId)) return true;
        if (entity && validSelectionIds.size > 0) {
          return !validSelectionIds.has(entity.id);
        }
        return false;
      })
      .map(([itemId]) => itemId);

    if (plotIdsToClear.length > 0) {
      pageDispatch({
        type: 'CLEAR_PRIMARY_ENTITIES',
        payload: { plotIds: plotIdsToClear },
      });
    }
  }, [pageState.primaryEntities, tabs, tabItems, selections, pageDispatch]);
};
